import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'

class DBPurchase {
  // 获取购买记录列表
  static getPurchaseRecordList(options) {
    let url = `/api/db/purchase/history/page?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
}
export default DBPurchase